import { Text } from 'blaze-ui/Text/Text'
import Styles from './CampaignDetails.module.scss'
import type { Icon } from 'blaze-ui/icons/Types'
import { Brand } from 'blaze-ui/icons'
import { Credits } from 'blaze-ui/icons/20/Credits'
import { ColorSwatch01, FileLock1 } from 'blaze-ui/icons/24'
import { SourceImageEditLevel } from 'types'
import { Pressable } from '@react-aria/interactions'
import cx from 'classnames'

export type ContentModificationVariant = 'none' | 'low' | 'medium' | 'high'

export const ICON_MAP: Record<ContentModificationVariant, Icon> = {
  high: Credits,
  medium: ColorSwatch01,
  low: Brand,
  none: FileLock1,
}

export const LABEL_MAP: Record<ContentModificationVariant, string> = {
  high: 'Growth-focused',
  medium: 'Balanced',
  low: 'Brand-first',
  none: 'Strict brand control',
}

export const DESCRIPTION_MAP: Record<ContentModificationVariant, string> = {
  high: 'Boosts performance with AI and smart swaps.',
  medium: 'Optimizes while preserving your brand look.',
  low: 'Stays close to your original assets.',
  none: 'Uses your assets without changes.',
}

type Props = {
  selected: boolean
  variant: ContentModificationVariant
  onSelect: (value: SourceImageEditLevel) => void
}

export const ContentModificationItem = (props: Props) => {
  const { variant, selected, onSelect } = props
  const IconComponent = ICON_MAP[variant]
  const label = LABEL_MAP[variant]
  const description = DESCRIPTION_MAP[variant]

  return (
    <Pressable onPress={() => onSelect(variant)}>
      <div className={cx(Styles.contentModificationItem, { [Styles.selected]: selected })}>
        <div className={Styles.contentModificationItemIcon}>
          <IconComponent size={16} color="#8341DF" />
        </div>
        <div className={Styles.contentModificationItemText}>
          <Text variant="secondary" color="var(--dark-90)" fontWeight={selected ? '500' : '400'}>
            {label}
          </Text>
          <Text variant="secondary" color="var(--dark-40)">
            {description}
          </Text>
        </div>
      </div>
    </Pressable>
  )
}
